import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

export const useCaptureChatEntryLoadError = (error: Error | null, aggregateName: string) => {
    useEffect(() => {
        if (!error) return;
        Sentry.captureException(error, { tags: { aggregate: aggregateName, feature: 'whatsapp-chat-entry' } });
    }, [error, aggregateName]);
};
